// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum Traffic {
  P = 0,
  CarCall = 1,
  RearCarCall = 2,
  HallCall = 3,
  UpHallCall = 4,
  UpRearHallCall = 5,
  DownHallCall = 6,
  DownRearHallCall = 7,
  UpHallCallAssigned = 8,
  UpRearHallCallAssigned = 9,
  DownHallCallAssigned = 10,
  DownRearHallCallAssigned = 11,
  CarCallAnswered = 12,
  RearCarCallAnswered = 13,
  HallCallAnswered = 14,
  UpHallCallAnswered = 15,
  UpRearHallCallAnswered = 16,
  DownHallCallAnswered = 17,
  DownRearHallCallAnswered = 18,
}
